import { ArrowRight, Play, ShieldCheck, Sparkles } from "lucide-react";
import StaticPhone from "./StaticPhone";

const Hero = ({ onTryDemo, onStartTrial }) => {
  return (
    <section
      data-testid="hero-section"
      className="relative pt-28 sm:pt-32 pb-20 sm:pb-28 overflow-hidden"
    >
      {/* Soft background blobs */}
      <div
        className="pointer-events-none absolute -top-40 -right-32 w-[520px] h-[520px] rounded-full blur-3xl opacity-30"
        style={{ background: "#A7F3D0" }}
      />
      <div
        className="pointer-events-none absolute -bottom-40 -left-32 w-[420px] h-[420px] rounded-full blur-3xl opacity-25"
        style={{ background: "#25D366" }}
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">
        {/* Left – copy */}
        <div className="lg:col-span-7">
          <div
            data-testid="hero-eyebrow"
            className="inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-[#189346] bg-[#E9FBF0] border border-[#25D366]/20"
          >
            <Sparkles className="w-3.5 h-3.5" />
            Coach d'organisation scolaire
          </div>

          <h1
            data-testid="hero-headline"
            className="mt-6 font-display text-4xl sm:text-5xl lg:text-[64px] leading-[1.05] font-extrabold tracking-tight text-[#122118]"
          >
            L'étude à la maison ne devrait pas être{" "}
            <span className="relative inline-block">
              <span className="relative z-10">une bataille</span>
              <span
                aria-hidden
                className="absolute left-0 right-0 bottom-1.5 h-3 -z-0"
                style={{ background: "#A7F3D0", opacity: 0.7 }}
              />
            </span>{" "}
            tous les soirs.
          </h1>

          <p
            data-testid="hero-subheadline"
            className="mt-6 text-lg sm:text-xl text-[#4a5f53] max-w-xl leading-relaxed"
          >
            Plan Étude aide votre enfant à respecter un plan d'étude simple —
            avec des rappels et un suivi réel, envoyés directement
            chaque semaine au parent.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <button
              onClick={onTryDemo}
              data-testid="hero-demo-button"
              className="group inline-flex items-center justify-center gap-2 rounded-full px-7 py-4 text-base font-semibold transition-all shadow-sm hover:shadow-md"
              style={{
                background: "var(--sp-primary)",
                color: "var(--sp-text-on-primary)",
              }}
            >
              <Play className="w-4 h-4 fill-current" />
              Voir la démo en direct
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
            </button>
            <button
              type="button"
              onClick={onStartTrial}
              data-testid="hero-trial-button"
              className="inline-flex items-center justify-center gap-2 rounded-full px-7 py-4 text-base font-semibold text-[#122118] bg-white border border-gray-200 hover:border-gray-300 hover:bg-gray-50 transition-all"
            >
              Essayer gratuitement 30 jours
            </button>
          </div>

          <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-sm text-[#4a5f53]">
            <span className="inline-flex items-center gap-2">
              <ShieldCheck className="w-4 h-4 text-[#189346]" />
              Aucune carte requise
            </span>
            <span className="inline-flex items-center gap-2">
              <ShieldCheck className="w-4 h-4 text-[#189346]" />
              Annulation en 1 clic
            </span>
            <span className="inline-flex items-center gap-2">
              <ShieldCheck className="w-4 h-4 text-[#189346]" />
              Données sécurisées
            </span>
          </div>
        </div>

        {/* Right – Phone */}
        <div className="lg:col-span-5 flex justify-center lg:justify-end relative">
          <button
            onClick={onTryDemo}
            data-testid="hero-phone-trigger"
            className="group relative cursor-pointer focus:outline-none"
            aria-label="Voir la démo interactive"
          >
            <StaticPhone />
            {/* Play overlay on hover */}
            <span className="absolute inset-0 rounded-[44px] flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
              <span
                className="rounded-full px-5 py-3 text-sm font-semibold flex items-center gap-2 shadow-lg"
                style={{
                  background: "rgba(18, 33, 24, 0.92)",
                  color: "#fff",
                  backdropFilter: "blur(8px)",
                }}
              >
                <Play className="w-4 h-4 fill-current" />
                Lancer la démo
              </span>
            </span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
